'use client';

import Fab from '@mui/material/Fab';
import Box from '@mui/material/Box';
import SvgIcon from '@mui/material/SvgIcon';

import { RouterLink } from 'src/routes/components';
import { paths, newSearchParams } from 'src/routes/paths';

import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

export function AddProductButton({ ref, sx, ...other }) {
  const { currentLang } = useTranslate();

  return (
    <Box
      ref={ref}
      component={RouterLink}
      href={`${paths.product.new}${newSearchParams({ country: currentLang.countryName })}`}
      sx={[
        {
          width: 48,
          height: 48,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Fab size="small" color="inherit">
        <SvgIcon>
          <path
            fill="currentColor"
            d="M18 13h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5V6a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2"
          />
        </SvgIcon>
      </Fab>
    </Box>
  );
}
